import React, { useEffect, useState } from "react";
import Button from "../../components/Button";
import DesktopContainerAuth from "../../components/DesktopContainerAuth";
import Loading from "../../components/Loading";
import PhoneInput from "../../components/PhoneInput";
import Radio from "../../components/Radio";
import TextInput from "../../components/TextInput";
import ContactAuth from "../../components/Views/ContactAuth";
import TermOfUse from "../../components/Views/TermOfUse";
import TitleAuth from "../../components/Views/TitleAuth";
import handleErrors from "../../helpers/handleErrors";
import { signup } from "../../services/auth";
import { schemaSignup, schemaSignupWithout } from "./validation";
import { useHistory } from "react-router-dom";
import BannerSignup from "components/BannerSignup";

type Props = {};

const Signup: React.FC<Props> = (): JSX.Element => {
  let history = useHistory();

  const [name, setName] = useState("");
  const [entityName, setEntityName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [subType, setSubType] = useState("lawyer");

  const [loading, setLoading] = useState<boolean>(false);
  const [final, setFinal] = useState(false);
  const [errors, setErrors] = useState<any>();

  const [role, setRole] = useState<string>("");
  useEffect(() => {
    localStorage.clear();
    setRole(history.location.pathname.split("/")[2]);
    localStorage.setItem("role", role);
  }, [history, role]);

  const addClassButton = () => {
    if (errors?.name || errors?.email || errors?.entityName || errors?.phone) {
      return "bg-bt-red text-bt-white";
    }

    if (subType === "entity") {
      if (name && email && entityName && phone) {
        return "bg-bt-green text-bt-white";
      }
    } else {
      if (name && email && phone) {
        return "bg-bt-green text-bt-white";
      }
    }

    return "bg-bt-light-gray text-bt-black";
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      if (subType === "agency") {
        if (
          !schemaSignup.isValidSync({ name, entityName, email, phone, subType })
        ) {
          handleErrors({
            schema: schemaSignup,
            stateData: { name, entityName, email, phone, subType },
            setErrorMessage: setErrors,
          });
          setLoading(false);
          return;
        }
      } else {
        if (
          !schemaSignupWithout.isValidSync({
            name,
            email,
            phone,
            subType,
          })
        ) {
          handleErrors({
            schema: schemaSignupWithout,
            stateData: { name, email, phone, subType },
            setErrorMessage: setErrors,
          });
          setLoading(false);
          return;
        }
      }

      await signup({
        name,
        entityName,
        email,
        phone,
        subtype: subType,
      });
      setFinal(true);
    } catch (error: any) {
      if (error.response.data.error === "Email already in use.") {
        setErrors({ email: "Email already in use" });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <DesktopContainerAuth>
      <Loading loading={loading} />
      <div className="flex flex-col">
        <div className="w-96 mx-auto">
          {!final ? (
            <>
              <TitleAuth title={"Are you an entity or lawyer?"} />
              <div className="flex flex-col">
                <div className="flex flex-row justify-around mt-3.5 mb-6">
                  <div className="flex flex-col">
                    <Radio
                      radioStyle="rounded-md w-7 h-7 font-light focus:ring-0 checked:bg-bt-white checked:border-bt-gray-500 checked:after:content-['X'] checked:after:ml-2 checked:after:text-bt-purple"
                      label={"Entity"}
                      value={"agency"}
                      defaultChecked={subType === "agency" ? true : false}
                      onChange={(e) => setSubType(e.target.value)}
                      name={"subType"}
                      className="text-xl text-purple font-light"
                    />
                  </div>
                  <div className="flex flex-col">
                    <Radio
                      radioStyle="rounded-md w-7 h-7 font-light focus:ring-0 checked:bg-bt-white checked:border-bt-gray-500 checked:after:content-['X'] checked:after:ml-2 checked:after:text-bt-purple"
                      label={"Lawyer"}
                      value={"lawyer"}
                      defaultChecked={subType === "lawyer" ? true : false}
                      onChange={(e) => setSubType(e.target.value)}
                      name={"subType"}
                      className="text-xl text-purple font-light"
                    />
                  </div>
                </div>
              </div>
              <TextInput
                placeholder={"Name"}
                value={name}
                onChange={(e) => setName(e.target.value)}
                isHelp={errors?.name}
                helpText={errors?.name}
              />
              {subType === "agency" && (
                <TextInput
                  placeholder={"Entity"}
                  value={entityName}
                  onChange={(e) => setEntityName(e.target.value)}
                  isHelp={errors?.entityName}
                  helpText={errors?.entityName}
                />
              )}
              <TextInput
                placeholder={"Email"}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                isHelp={errors?.email}
                helpText={errors?.email}
              />
              <PhoneInput
                placeholder={"Phone"}
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                isHelp={errors?.phone}
                helpText={errors?.phone}
              />
              <Button
                label={"Send request"}
                className={`mt-12 rounded-lg font-sora font-normal2 text-base h-12 w-full ${addClassButton()}`}
                onClick={handleSubmit}
              />
              <span
                className="flex font-nunito justify-center mt-2.5 text-sm"
                style={{
                  fontStyle: "normal",
                  fontWeight: 400,
                  color: "#43425D",
                }}
              >
                Our team will contact you as soon as possible
              </span>
            </>
          ) : (
            <BannerSignup />
          )}
        </div>
        <ContactAuth
          title={"Have an account?"}
          subTitle={
            "If you’re already registered and your adoption organization is already a Bridge Talk partner, please click here:"
          }
          titleButton={"Login"}
          action={"/login/entity"}
        />
        <TermOfUse />
      </div>
    </DesktopContainerAuth>
  );
};

export default Signup;
